import '../shared/index';
import './components';
import './stores';

import { debounce } from '../../auto/utils/debounce';
import { setViewItemEventOnDirectSalePageLoad } from '../../auto/utils/setViewItemEventOnDirectSalePageLoad';
import isMobile from '../../auto/utils/isMobile';
import {
  makeCarousel,
  makeUnmountedCarousel,
} from '../../auto/utils/carousel/splide';

import DDMDataLayerService from '../../auto/services/ddm_data_layer_service/DDMDataLayerService';
import { DirectSalesAdapter } from '../../auto/services/ddm_data_layer_service/adapters/directSalesAdapter';

window.makeCarousel = makeCarousel;
window.makeUnmountedCarousel = makeUnmountedCarousel;

window.debounce = debounce;
window.isMobile = isMobile;
window.DDMDataLayerService = new DDMDataLayerService();
window.DDMDataLayerHelpers = {
  DirectSalesAdapter,
};

window.helpers = {
  ...window.helpers,
  setViewItemEventOnDirectSalePageLoad,
};
